<template>
	<div v-loading="loading">
	    <el-form :model="formAdd" ref="formAdd" :rules="rulesAdd" label-width="120px" label-position="right" size="small" style="margin-right: 3vw">
	        <el-row>
	            <el-col :span="24">
	                <el-form-item label="标题" prop="news_title" label-width="120px" style="height: 50%">
	                    <el-input v-model="formAdd.news_title"></el-input>
	                </el-form-item>
	            </el-col>
	        </el-row>
            <el-row>
	            <el-col :span="24">
	                <el-form-item label="副标题" prop="news_subtitle" label-width="120px" style="height: 50%">
	                    <el-input v-model="formAdd.news_subtitle"></el-input>
	                </el-form-item>
	            </el-col>
	        </el-row>
            <el-row>
	            <!-- <el-col :span="12">
	                <el-form-item label="模块" prop="news_model" label-width="120px" style="height: 50%">
                        <el-select v-model="formAdd.news_model" filterable style="width:110px" disabled>
                            <el-option v-for="item in newsmodellist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
	                </el-form-item>
	            </el-col> -->
                <el-col :span="12">
	                <el-form-item label="模块栏目" prop="model_item" label-width="120px" style="height: 50%">
                        <el-select v-model="formAdd.model_item" filterable placeholder="请选择" style="width:110px">
                            <el-option v-for="item in modelitemlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
	                </el-form-item>
	            </el-col>
				<el-col :span="12">
					<el-form-item label="发布时间" prop="publish_time" label-width="120px" style="height: 50%">
                    	<el-date-picker v-model="formAdd.publish_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker> 
	                </el-form-item>
				</el-col>
	        </el-row>
            <el-row>
                <el-col :span="12">
	                <el-form-item label="新闻来源" prop="news_source" label-width="120px" style="height: 50%">
	                    <el-input v-model="formAdd.news_source"></el-input>
	                </el-form-item>
	            </el-col>
                <el-col :span="12">
	                <el-form-item label="作者/编辑" prop="news_author" label-width="120px" style="height: 50%">
	                    <el-input v-model="formAdd.news_author"></el-input>
	                </el-form-item>
	            </el-col>
            </el-row>
			<el-row>
	            <el-col :span="24">
				 <el-form-item label="正文内容" prop="news_content" label-width="120px" style="height: 50%">
	                  <Xheditor :height="300"  ref="editor" :text="formAdd.news_content" :fileID="fileID" :tableName="tableName"  @change="change"></Xheditor>
	              </el-form-item>
	            </el-col>
	        </el-row>
			<el-row>
	            <el-col :span="24">
				 <el-form-item label="备注" prop="remark" label-width="120px" style="height: 50%">
					<el-input v-model="formAdd.remark"></el-input>
	              </el-form-item>
	            </el-col>
	        </el-row>
			<el-row>
				<el-col :span="6">
                    <el-form-item label="是否直接打开网址" prop="is_open_url" label-width="220px">
                        <el-radio-group v-model="formAdd.is_open_url" @change="changeOpenUrl">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
				</el-col>
				<el-col :span="18" v-if="formAdd.is_open_url==='1'">
					<el-form-item label="网址" prop="url" label-width="120px" style="height: 50%">
						<el-input v-model="formAdd.url" placeholder="示例：https://www.baidu.com/"></el-input>
					  </el-form-item>
				</el-col>
			</el-row>
            <el-row v-if="formAdd.news_model==='NewsType'">
	            <el-col :span="12">
                    <el-form-item label="是否展示到首页头条" prop="is_show_index" label-width="220px" style="height: 50%">
                        <el-radio-group v-model="formAdd.is_show_index">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
	            </el-col>
				<el-col :span="12">
                    <el-form-item label="是否展示到首页" prop="is_show_main" label-width="220px" style="height: 50%">
                        <el-radio-group v-model="formAdd.is_show_main">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                      </el-form-item>
	            </el-col>
	        </el-row>
            <el-row v-if="(formAdd.news_model==='PartyType')&&(formAdd.model_item==='PT03'||formAdd.model_item==='PT04')">
	            <el-col :span="12">
                    <el-form-item label="是否轮播" prop="is_broadcast" label-width="220px" style="height: 50%">
                        <el-radio-group v-model="formAdd.is_broadcast">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
	            </el-col>
	        </el-row>
            <el-row>
	            <el-col :span="12">
                    <el-form-item label="是否直接查看附件" prop="is_open_attachment" label-width="220px" style="height: 50%">
                        <el-radio-group v-model="formAdd.is_open_attachment" @change="changeOpenAtt">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
	            </el-col>
	        </el-row>
            <el-row>
                <el-col :span="12" v-if="formAdd.news_model==='NewsType'||formAdd.news_model==='PartyType'">
                    <el-form-item label="封面" required label-width="120px" style="height: 50%">
						<div style="color: #fd0202;">上传图片大小不能超过0.3MB</div>
                        <AttachmentUpload v-if="!formAdd.isView" ref="fileUpload1" :isShow="true" :objectID="formAdd.id" :UseType="1" :MaxFileNum="1"
                                          :TableName="'t_news_main'" :fileType="['jpeg', 'bmp','jpg','png','gif']" :fileSize="0.3" @input="getAttachList(1)"></AttachmentUpload>
                        <AttachmentList ref="fileList1" :objectID="formAdd.id" :UseType="1"
                                        :TableName="'t_news_main'" :ShowDelete="!formAdd.isView"></AttachmentList>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="附件" prop="att_list" label-width="120px" style="height: 50%">
                        <AttachmentUpload v-if="!formAdd.isView" ref="fileUpload0" :isShow="true" :objectID="formAdd.id" :UseType="0" :MaxFileNum="1"
                                          :TableName="'t_news_main'" :fileType="['doc','docx','xls','xlsx','pdf','mp4','avi','flv','mov','wmv','ppt','pptx']" @input="getAttachList(0)"></AttachmentUpload>
                        <AttachmentList ref="fileList0" :objectID="formAdd.id" :UseType="0"
                                        :TableName="'t_news_main'" :ShowDelete="!formAdd.isView"></AttachmentList>
                    </el-form-item>
                </el-col>
            </el-row>
	    </el-form>
        
	    <div style="text-align:center;" v-if="!formAdd.isView">
	        <el-button type="primary" @click="saveAdd" size="small">提交</el-button>
	    </div>
	</div>
</template>
<script>
	import Xheditor from "@/components/XhComponents/XhEditor";
    import AttachmentList from "@/components/AttachmentList";
    import AttachmentUpload from "@/components/AttachmentUpload";
    export default{
        name: "NewsEdit",
		props: ["data", "title"],
          components: { Xheditor, AttachmentList, AttachmentUpload },
		data() {
			return {
				formAdd: this.data,
				value1: new Date(2016, 9, 10, 18, 40),
				rulesAdd: {
					news_title: [{ required: true, message: "必选项", trigger: "blur" }],
					news_subtitle: [{ required: true, message: "必选项", trigger: "blur" }],
					publish_time:[{ required: true, message: "必选项", trigger: "blur" }],
					model_item: [{ required: true, message: "必选项", trigger: "blur" }],
					news_source: [{ required: true, message: "必选项", trigger: "blur" }],
					news_author: [{ required: true, message: "必选项", trigger: "blur" }],
					news_content: [{ required: true, message: "必选项", trigger: "blur" }],
					is_show_index: [{ required: true, message: "必选项", trigger: "blur" }],
					is_show_main: [{ required: true, message: "必选项", trigger: "blur" }],
					is_broadcast: [{ required: true, message: "必选项", trigger: "blur" }],
					is_open_attachment: [{ required: true, message: "必选项", trigger: "blur" }],
					is_open_url: [{ required: true, message: "必选项", trigger: "blur" }],
				},
				loading: false,
                newsmodellist: [{ value: "NewsType", label: "新闻中心" },{ value: "InvestType", label: "投资者关系" },{value:"PartyType",label:"党务建设"}],
				modelitemlist:[{ value: "NT01", label: "公司动态",type:"NewsType" },{value: "NT02", label: "媒体关注",type:"NewsType"},{value: "NT03", label: "行业新闻",type:"NewsType"},{value: "NT04", label: "影像先河",type:"NewsType"},{value: "IT01", label: "公告信息",type:"InvestType"},{value: "IT02", label: "投资者教育",type:"InvestType"},{value: "PT01", label: "党建工作",type:"PartyType"},{value: "PT02", label: "党建文化",type:"PartyType"},{value: "PT03", label: "社会责任",type:"PartyType"},{value: "PT04", label: "党建活动",type:"PartyType"}],
                fileID:this.data.id,
				tableName:"t_news_main"
			}
		},
       methods:{
			saveAdd() {
			    let that = this;
				if(that.formAdd.url!=""){
					if(that.isValidUrl(that.formAdd.url)==false)
					{
						that.$message.warning("请输入正确的URL");
						return false;
					}
				}
				if(that.formAdd.is_open_url=="1")
				{
					if((that.formAdd.url==""))
					{
						that.$message.warning("请输入正确的URL");
						return false;
					}
				}
				if(that.formAdd.is_open_attachment=="1")
				{
					that.formAdd.att_list0 = that.$refs["fileList0"].DocData.length == 0 ? null : 1;
					if(that.formAdd.att_list0==null)
					{
						that.$message.warning("请上传附件");
						return false;
					}
				}
				if(that.formAdd.news_model==='NewsType'||that.formAdd.news_model==='PartyType'){
					that.formAdd.att_list = that.$refs["fileList1"].DocData.length == 0 ? null : 1;
					if(that.formAdd.att_list==null)
					{
						that.$message.warning("请上传封面");
						return false;
					}
				}
			    that.$refs.formAdd.validate((valid) => {
			        if (valid) {
			            that.$api.post("/newsCenter/saveNews",that.formAdd,
			                function (res) {
			                    if (res.code === "200") {
                                    that.$refs["fileList0"].Clear();//清空数据
									if(that.formAdd.news_model==='NewsType'||that.formAdd.news_model==='PartyType'){
										that.$refs["fileList1"].Clear();//清空数据
									}
									
			                        that.$emit("closeModal");
			                        that.$message.success(res.msg);
								 	that.$refs["editor"].reaload();
			                    } else {
			                        that.$message.warning(res.msg);
			                    }
			                },
			                function (res) {
			                    that.$message.error("服务异常，信息出错");
			                }
			            );
			        } else {
			            return false;
			        }
			    });
			},
			afterload() {
			    this.loading = false;
			},
            getAttachList(id) {
                this.$refs["fileList" + id].GetAttachmentList();
            },
			change(val) {
				var that = this;
				that.formAdd.news_content= val;
			},
			changeOpenAtt(val)
			{
				var that = this;
				if(val=="1"){
					that.formAdd.is_open_url = "0";
				}
			},
			changeOpenUrl(val)
			{
				var that = this;
				if(val=="1"){
					that.formAdd.is_open_attachment = "0";
				}
			},
			isValidUrl(url) {
				var pattern = /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^!=%&:/~+#-]*[\w@?^=%&/~+#-])?$/
				return pattern.test(url);
			},
		},
		mounted() {
			this.modelitemlist = this.modelitemlist.filter(item => { return item.type == this.data.news_model; });
            this.getAttachList(0);
            if(this.data.news_model==='NewsType'||this.data.news_model==='PartyType'){
				this.getAttachList(1);
			}
			
		},
		created() {
		},
		watch: {
            data: function () {
                this.formAdd = this.data;
                this.getAttachList(0);
				if(this.data.news_model==='NewsType'||this.data.news_model==='PartyType'){
				this.getAttachList(1);
			}
            },
		}
    }
</script>
<style lang="less">

</style>
	